import { Button, H2, H3, Separator } from "@dune/ui";
import { FormProvider } from "react-hook-form";
import DatesDetailsContainer from "../../../../component/brokers/constructionSites/DatesDetailsContainer";
import { useConstructionSiteDetailsForm } from "../../../../component/brokers/constructionSites/useConstructionSiteDetailsForm";

import { PAGES } from "@dune/types";
import { GFAFullDetails } from "@dune/types";
import { useNavigate } from "react-router-dom";
import InterventionsDetailsContainer from "../../../../component/brokers/constructionSites/InterventionsDetailsContainer";
import GFAAutorisationsContainer from "../../../../component/gfa/GFAAutorisationsContainer";
import { GFADocumentsTable } from "../../../../component/gfa/GFADocumentsTable";
import { useGFAAutorisationsAndReferencesForm } from "../../../../component/gfa/useGFAAutorisationsAndReferencesForm";
import { MainDetailsOperation } from "../../../constructionSites/components/tabs/operation";

interface GFAOperationTabProps {
	gfa: GFAFullDetails;
}

export const GFAOperationTab = ({ gfa }: GFAOperationTabProps) => {
	const navigate = useNavigate();
	// const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);

	const { form: constructionSiteDetailsForm } =
		useConstructionSiteDetailsForm(gfa);

	const { form: autorisationsAndReferencesForm } =
		useGFAAutorisationsAndReferencesForm(gfa ?? null);

	if (!gfa) return <div>Aucune projet GFA trouvé</div>;

	return (
		<div>
			<div className="flex justify-between items-center">
				<H2>Opération</H2>
				<Button
					type="button"
					onClick={() =>
						navigate(PAGES.GFA.edit.withParams(gfa.id.toString(), 2))
					}
				>
					Modifier l'opération
				</Button>
			</div>
			<FormProvider {...constructionSiteDetailsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">INFORMATIONS SUR L'OPÉRATION</H3>
						</div>
						<MainDetailsOperation isDisabled noShadow />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="OPERATION_INFORMATION_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />

			<FormProvider {...autorisationsAndReferencesForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">AUTORISATIONS ADMINISTRATIVES</H3>
						</div>

						<GFAAutorisationsContainer isForm={false} />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="ADMINISTRATIVE_AUTHORIZATION_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />

			<FormProvider {...constructionSiteDetailsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<H3>DATES DE L'OPÉRATION</H3>
						<DatesDetailsContainer noShadow isDisabled />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="OPERATION_DATES_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />

			<FormProvider {...constructionSiteDetailsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">INTERVENANTS PREVUS</H3>
						</div>
						<InterventionsDetailsContainer isDisabled />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="INTERVENTION_DETAILS_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>
		</div>
	);
};
